import classNames from 'classnames';
import Text from 'components/ui/Text';
import { FC } from 'react';

type LoadingProps = {
  text: string;
  opaqueBackdrop?: boolean;
  className?: string;
  show?: boolean;
};

const Loading: FC<LoadingProps> = ({
  text,
  opaqueBackdrop,
  className,
  show,
}) => {
  const classes = classNames(
    'fixed inset-0 flex items-center justify-center transition z-30',
    opaqueBackdrop ? 'bg-white' : 'bg-white/30',
    show ? '' : 'opacity-0 pointer-events-none',
    className,
  );

  return (
    <div className={classes}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="h-32 w-32">
          <div className="absolute inset-0 border-t-[8px] border-grey-200 animate-[loading1_5s_ease-in-out_infinite]"></div>
          <div className="absolute inset-0 border-r-[8px] border-grey-200 animate-[loading2_5s_ease-in-out_infinite]"></div>
          <div className="absolute inset-0 border-l-[8px] border-grey-200 animate-[loading3_5s_ease-in-out_infinite]"></div>
          <div className="absolute inset-0 border-b-[8px] border-grey-200 animate-[loading4_5s_ease-in-out_infinite]"></div>
        </div>
      </div>
      <Text elementType="div" bold size="xlarge" color="blue" className="z-10">
        {text}
      </Text>
    </div>
  );
};

export default Loading;
